// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'

import ConversationsDetail from 'syft-acp-core/entities/ConversationsDetail'
import PageTitle from 'syft-acp-core/components/PageTitle'

export const WatchlistConversationsView = ({ match: { params } }) => (
  <PageTitle title={[`Conversation ${params.id}`, 'Watchlist']}>
    <ConversationsDetail id={Number(params.id)} />
  </PageTitle>
)
